<template>
  <v-container align-center justify-center fill-height>
    <v-card>
      <v-img :src="require('../assets/404.png')"></v-img>
      <v-card-actions>
        <v-btn
          :to="{ name: 'Home' }"
          text
          color="orange">
          Back
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'Notfound',
  data: () => ({
    title: 'Page Not Found',
  }),
  created: () => ({
  }),
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
